import { render } from "./BackGroundManageDialog.vue?vue&type=template&id=2a7b9480&scoped=true"
import script from "./BackGroundManageDialog.vue?vue&type=script&lang=js"
export * from "./BackGroundManageDialog.vue?vue&type=script&lang=js"

import "./BackGroundManageDialog.vue?vue&type=style&index=0&id=2a7b9480&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7b9480"]])

export default __exports__